import { useCallback } from 'react';
import { createSeizure, generatePostSeizure, renderPayloadSeizure } from 'services/files';
import { useFlash } from 'contexts/flash';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { TAB_CONTROL_PANEL } from 'const/admin';
import { FormPostSeizure } from '../components/modules/FormPostSeizure/FormPostSeizure';
import axios from 'axios';

export const useCreatePostSeizure = () => {
  const { setFlash } = useFlash();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const onSubmitPostSeizure = useCallback(
    async (formData: FormPostSeizure) => {
      const formData2 = new FormData();
      let filePhotosIds: number[] = [];
      const filePhotos = formData.fileDocumentAdd;
      if (filePhotos?.length) {
        for (let x = 0; x < filePhotos.length; x++) {
          formData2.append('files', filePhotos[x], filePhotos[x]!.name);
        }
        const { data: resListIdFile } = await axios.post(
          '/storages/post_seizures_document',
          formData2,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        );
        filePhotosIds = resListIdFile.files;
        formData2.delete('files');
      }

      const payload = renderPayloadSeizure(formData, filePhotosIds);
      const data = await createSeizure(payload);
      navigate(`/admin/redemptions/post-seizure/edit/${data.filePostSeizure.id}`);
      setFlash({ type: 'success', message: 'Create post seizure successful' });
      navigate(`/admin/redemptions`);
    },
    [setFlash]
  );
  const { asyncCallback: asyncCreateSeizure } = useAsyncCallback(onSubmitPostSeizure, []);

  const handleGenerate = async (formData: FormPostSeizure) => {
    const formData2 = new FormData();
    let filePhotosIds: number[] = [];
    const filePhotos = formData.fileDocumentAdd;
    if (filePhotos?.length) {
      for (let x = 0; x < filePhotos.length; x++) {
        formData2.append('files', filePhotos[x], filePhotos[x]!.name);
      }
      const { data: resListIdFile } = await axios.post(
        '/storages/post_seizures_document',
        formData2,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      );
      filePhotosIds = resListIdFile.files;
      formData2.delete('files');
    }
    const payload = renderPayloadSeizure(formData, filePhotosIds);
    const data = await createSeizure(payload);
    if (data.filePostSeizure.id) {
      await generatePostSeizure(data.filePostSeizure.id, payload);
      setFlash({ type: 'success', message: 'Generate successful' });
    }
    navigate(`/admin/redemptions/post-seizure/edit/${data.filePostSeizure.id}`);
  };
  const { asyncCallback: generateSeizure } = useAsyncCallback(handleGenerate, []);

  const handleOnBack = () => navigate(`/admin/control-panel?tab=${TAB_CONTROL_PANEL.ARCHIVE}`);

  return {
    onSubmitPostSeizure: asyncCreateSeizure,
    generateSeizure,
    handleOnBack,
    searchParams
  };
};
